import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useOverlayContext } from 'seagull';
import { AddPaymentMethodModal } from '../AddPaymentMethodModal';
export function useOpenAddPaymentMethodModal(clientId) {
    const { showModal } = useOverlayContext();
    return useCallback(()=>showModal({
            biName: 'client_detail_add_payment_method',
            openBottomSheetOnMobile: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(AddPaymentMethodModal, {
                    clientId: clientId,
                    dismissModal: dismissModal
                });
            }
        }), [
        clientId
    ]);
}
